import { render, staticRenderFns } from "./drugGeneModelCP.vue?vue&type=template&id=0c7895a2&"
import script from "./drugGeneModelCP.vue?vue&type=script&lang=js&"
export * from "./drugGeneModelCP.vue?vue&type=script&lang=js&"
import style0 from "./drugGeneModelCP.vue?vue&type=style&index=0&id=0c7895a2&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports